var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.captain)?_c('div',[_c('sala')],1):_c('div',[_c('cashier')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }